import React, {useEffect} from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import Background from "../Background/Background";
import styles from "./Layout.module.css";


export default function Layout({ children }) {
  

  return (
    <>
      <Navbar />
      <div className={styles.content}>
        {children}</div>
      <Footer />
      <Background />
    </>
  );
}
